var n = Object.defineProperty;
var c = (t, e, s) => e in t ? n(t, e, { enumerable: !0, configurable: !0, writable: !0, value: s }) : t[e] = s;
var p = (t, e, s) => c(t, typeof e != "symbol" ? e + "" : e, s);
import { HttpClient as o, httpClient as r } from "../../httpClient.js";
class a extends o {
  constructor() {
    super(...arguments);
    p(this, "endpoint", "/support-access");
  }
  async redeem(s) {
    return r.post(`${this.endpoint}/redeem`, s);
  }
  /** Admin-only: generates a code scoped to one user. */
  async generate(s) {
    return r.post(`/users/${s}/support-access`);
  }
}
const d = new a();
export {
  d as default
};
